import React, { useEffect, useState } from 'react';
import { DashboardContainer } from '../../components/ui/UtilsLayout';

const Profile = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchCurrentUser = async () => {
      try {
        const token = localStorage.getItem('token'); 

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/users/current-user`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        console.log('Current User Data:', data);
        setUserData(data.data); 
      } catch (error) {
        console.error('Error fetching current user:', error);
      }
    };

    fetchCurrentUser();
  }, []);

  return (
    <DashboardContainer>
      <div className="flex flex-col items-start justify-start w-full h-full">
        <div className="w-full lg:w-1/2 h-full flex flex-col items-start justify-start gap-10">
          {/* <Container title={'Settings'}></Container>
          <Container title={'Payment Method'}></Container> */}
          <h1 className="text-md font-bold text-[#979797]">Account Details</h1>
          <div className="w-full flex flex-col gap-6">
            <Container
              minH={'min-h-[45px]'}
              gap={'gap-2'}
              title2={'Name'}
            >
              <p className="text-white text-sm p-3">
                {userData?.name || '—'}
              </p>
            </Container>
            <Container minH={'min-h-[45px]'} gap={'gap-2'} title2={'Email'}>
              <p className="text-white text-sm p-3">{userData?.email || '—'}</p>
            </Container>

             <Container minH={'min-h-[45px]'} gap={'gap-2'} title2={'Phone Number'}>
              <p className="text-white text-sm p-3">{userData?.phoneNumber || '—'}</p>
            </Container>
            <Container
              minH={'min-h-[45px]'}
              gap={'gap-2'}
              title2={'Last Login'}
            >
              <p className="text-white text-sm p-3">
                {userData?.lastLogin
                  ? new Date(userData.lastLogin).toLocaleString('en-IN', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: true,
                    })
                  : '—'}
              </p>
            </Container>
          </div>
        </div>
      </div>
    </DashboardContainer>
  );
};

const Container = React.memo(
  ({ children, title, title2, minH = 'min-h-[100px]', gap = 'gap-4' }) => {
    return (
      <div className={`w-full flex flex-col ${gap}`}>
        {title && <h1 className="text-md font-bold text-[#979797]">{title}</h1>}
        {title2 && (
          <h1 className="text-sm font-bold text-[#979797]">{title2}</h1>
        )}
        <div
          className={`${minH} w-full bg-[#1E1F22] mt-2 rounded-[10px]`}
          style={{ boxShadow: '0px 0px 6px 0px #00000073' }}
        >
          {children}
        </div>
      </div>
    );
  }
);

export default Profile;
